import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { Subject, Subscription } from "rxjs";
import { AccountUpdate } from "src/model/class/general classes/account";
import { iCredential } from "src/model/interface/icredential";
import { AccountService } from "src/service/account.service";
import { AlertService } from "src/service/alert.service";
import { LoaderService } from "src/service/loader.service";
import { SystemRouterService } from "src/service/system-router.service";
import { PasswordValidators } from "src/validators/password-validators";

@Component({
    selector: "app-form-reset-password",
    templateUrl: "./form-reset-password.component.html",
    styleUrls: ["./form-reset-password.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormResetPasswordComponent implements OnInit {
  private _logContext: string = "form-create-account.component";
  private _formSubscriptions: Array<Subscription> = null;
  private _translateSubscription: Subscription = null;
  private _errorUnAuthorizeSubscription: Subscription = null;
  private _keyboardSubscriptions: Subscription = null;
  private _isPerformingLogin: boolean = false;
  private _errorCredentialLoginCount: number = 0;
  private _onPerformUnauthorizeAccess = new Subject<number>();

  //#region Translate variable
  private _lblpasswordMustMatch: string = "";
  //#endregion

  public formResetPWD: UntypedFormGroup = null;
  public cssPlatformClass: string = "";
  public forcedActive: boolean = false;

  @Output() onResetPassword: EventEmitter<any> = new EventEmitter();

  constructor (
    private _fb: UntypedFormBuilder,
    private _alertService: AlertService,
    private _translateService: TranslateService,
    private _routerService: SystemRouterService,
    private _systemRouterService: SystemRouterService,
    private _accountService: AccountService,
    private _loaderService: LoaderService
  ) { }

  ngOnInit() {
    this.forcedActive = false;

    this.loadTranslation();
    //this.subscribeTranslationEvent();

    this.initializeCreateAccountForm();
    this.subscribeFormEvent();
  }

  ngOnDestroy() {
    this.unsubscribeFormEvent();

    this._translateSubscription?.unsubscribe();
    this._errorUnAuthorizeSubscription?.unsubscribe();
    this._keyboardSubscriptions?.unsubscribe();
  }

  /**
   * Load translated strings
   */
  public loadTranslation(): void {
    this._translateService
      .get(["dictionary.passwordMustMatch"])
      .subscribe((translatedStrings) => {
        this._lblpasswordMustMatch =
          translatedStrings["dictionary.passwordMustMatch"];
      });
  }

  //#endregion
  /**
   * Enter pressed in a field: same as the confirm button, when the form is valid
   */
  public async onSubmitForm(): Promise<void> {
    if (this.formResetPWD.valid) {
      await this.performConfirm();
    }
  }

  /**
   * Handle click login button
   *
   * @returns
   */
  public async onClickConfirm(): Promise<void> {
    await this.performConfirm();
  }

  /**
   * Return to login page
   */
  public onClickGoBack() {
    this._systemRouterService.navigateToDigitalPlaceLogin();
  }

  /**
   * Handle callback event for request login
   *
   * @param objectLogin
   */
  public async onRequestLogin(objectLogin: iCredential): Promise<void> {
    if (!this._isPerformingLogin) {
    }
  }

  /**
   * Initialize login form plant
   */
  private initializeCreateAccountForm(): void {
    this.formResetPWD = this._fb.group({
      password: new UntypedFormControl("", {
        validators: Validators.compose([
          Validators.minLength(4),
          Validators.required,
          PasswordValidators.isPWDCorret(),
        ]),
      }),
      confirmPassword: new UntypedFormControl("", {
        validators: Validators.compose([
          Validators.minLength(4),
          Validators.required,
          PasswordValidators.isPWDCorret(),
        ]),
      }),
    });
  }

  /**
   * Subscribe value change event from each form field.
   */
  private subscribeFormEvent(): void {
    this._formSubscriptions = new Array<Subscription>();
    // "The two passwords must match" under the confirmation field, while typing
    this._formSubscriptions.push(PasswordValidators.watchPasswordMatch(this.formResetPWD));
  }

  /**
   * Perform create account procedure.
   *
   * @returns
   */
  private async performConfirm(): Promise<void> {
    try {
      if (
        this.formResetPWD.value.confirmPassword ==
        this.formResetPWD.value.password
      ) {
        this.onResetPassword.emit(this.formResetPWD.value.password);
      } else {
        this.formResetPWD.get("confirmPassword").setErrors({ incorrect: true });

        await this._alertService.presentAlertOk(
          "",
          "",
          this._lblpasswordMustMatch
        );
      }
    } catch (exception) { }
  }

  /**
   * Perform account registration
   *
   * @param accountNew Account new data
   */
  private async performRegistration(accountNew: AccountUpdate): Promise<void> { }

  /**
   * Unsubscribe to form event events
   */
  private unsubscribeFormEvent(): void {
    for (const sub of this._formSubscriptions) {
      sub.unsubscribe();
    }
  }
}
